import config from '@/config/config';

import Index from '@/pages/contact/index.vue';
import List from '@/pages/contact/list/list.vue';
import View from '@/pages/contact/view/view.vue';
import New from '@/pages/contact/new/new.vue';
import Edit from '@/pages/contact/edit/edit.vue';

const modulePermission = config.modules.contact;

export default {
  path: '/contact',
  name: 'contact',
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: 'enabled_read',
  },
  children: [
    {
      path: 'list',
      name: 'contact-list',
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
    },
    {
      path: ':id',
      name: 'contact-view',
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
      props: true,
    },
    {
      path: 'new/:id_company',
      name: 'contact-new',
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_create',
      },
      props: true,
    },
    {
      path: ':id/e',
      name: 'contact-edit',
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_edit',
      },
      props: true,
    },
  ],
};
